// tslint:disable
export enum Gender {
    /**
     * @description Unknown
     */
    UNKN = 0,
    /**
     * @description Male
     */
    M = 1,
    /**
     * @description Female
     */
    F = 2,
    /**
     * @description Indeterminate
     */
    I = 3,
    /**
     * @description Transgender
     */
    T = 4,
    /**
     * @description Prefer not to answer
     */
    PNTA = 5,
}
